import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import { Link } from "react-router-dom"
import FullTable from "components/FullTable"
import buildersInProperties from "helpers/buildersInProperties"
import helpers from "helpers/helpers"
import settings from "settings"

class FloorplanManagagement extends Component {
	constructor(props) {
		super(props)

		this.state = {
			filtered: [],
			columns: [
				{
					Header: "ID",
					accessor: "id",
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => {
						if (r.name?.props?.children?.toLowerCase().includes(f.value.toLowerCase())) {
							return true
						}
					},
					sortMethod: (a, b) => {
						try {
							let aVal = a.props.children
							let bVal = b.props.children
							// Extract street numbers for comparison
							let aName = parseInt(aVal.match(/^\d+/) || [0], 10)
							let bName = parseInt(bVal.match(/^\d+/) || [0], 10)

							// Compare street numbers numerically
							if (aName !== bName) {
								return aName - bName
							}

							// If street numbers are the same, compare the full string
							return aVal.localeCompare(bVal)
						} catch (e) {
							console.log(e)
						}
					},
				},
				{
					Header: "Plan Number",
					accessor: "plan_number",
					filterMethod: (f, r) => helpers.tableText(f, r, "plan_number"),
				},
				{
					Header: "Feed Name",
					accessor: "feed_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "feed_name"),
				},
				{
					Header: "Sq. Ft",
					accessor: "sqft",
				},
				{
					Header: "Stories",
					accessor: "stories",
				},
				{
					Header: "Beds",
					accessor: "beds",
				},
				{
					Header: "Full Baths",
					accessor: "full_baths",
				},
				{
					Header: "Half Baths",
					accessor: "half_baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
				},
				{
					Header: "Developer Lot Count",
					accessor: "lot_count",
				},
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Edit",
					accessor: "edit",
				},
			],
		}

		if (settings.arc) {
			this.state.columns.splice(this.state.columns.length - 1, 0, {
				Header: "Approved In",
				accessor: "approved_in",
				filterMethod: (f, r) => helpers.tableText(f, r, "approved_in"),
			})
		}
	}

	buildTable = (type) => {
		let data = []
		// List of builders in selected communities
		let builders = buildersInProperties(this.props.payload.public.builders, this.props.activeProperties)
		builders = _.uniq(builders)
		_.forEach(this.props.payload.public.floorplans, (v) => {
			if (!builders.includes(v.builder) && this.props.activeProperties.length > 0) {
				return
			}
			let r = {}
			r.id = v.id
			r.name = <Link className="underline" to={`/admin/floorplans/${v.id}`}>{v.name}</Link>
			r.plan_number = v.plan_number
			r.feed_name = v.feed_name
			r.beds = v.beds
			r.full_baths = v.full_baths
			r.half_baths = v.half_baths
			r.garage = v.garage
			r.sqft = v.sqft
			r.stories = v.stories
			r.lot_count = v.lot_count
			r.status = v.status === 1 ? "Enabled" : "Disabled"
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				r.builder = builder.name
			}
			if (settings.arc) {
				try {
					let approvedIn = []
					_.forEach(v.arc_approved, (p) => {
						if (!p.approved) return
						let property = _.find(this.props.payload.public.properties, { id: p.property })
						if (property) {
							approvedIn.push(property.name)
						}
					})
					r.approved_in = approvedIn.join(", ")
					r.approved_in = _.trim(r.approved_in, ", ")
				} catch (e) {
					console.log(e)
				}
			}
			r.edit = (
				<Link to={`/admin/floorplans/${v.id}`}>
					<i className="far fa-edit"></i>
				</Link>
			)
			data.push(r)
		})
		return data
	}

	excelClean = (data) => {
			let ret = []
			_.forEach(data, (v, ind) => {
				_.forEach(v._original, (r, k) => {
					if (r && typeof r === "object" && k !== "addl") {
						data[ind]._original[k] = r.props?.children
					}
				})
				ret.push(v)
			})
			return ret
		}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="communities">
					<Title title="Floorplan Management" showDate={false} />
					<div className="content">
						<div className="admin__add">
							<Link to={"/admin/floorplans/add"}>
								<i className="fas fa-plus-circle" />
							</Link>
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="floorplans"
							title="Floorplans"
							excelClean={this.excelClean}
							unset={["edit"]}
							pageSize={20}
							defaultSorted={[
								{
									id: "builder",
									asc: true,
								},
								{
									id: "name",
									asc: true,
								},
							]}
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FloorplanManagagement)
